
export const CONSENT_DATA = [
    {
        name: "confidentiality",
        title: "Confidentiality Agreement",
        text: <span>
                    I acknowledge that I have read and agree to the terms of the &nbsp;
                    <a href={"docs/neurocrine_visitor_CDA.pdf"} rel={"noreferrer"} target={"_blank"}>
                    Confidential Disclosure Agreement (CDA)</a>. I understand that I may receive or be exposed to
                    confidential or non-public information during the event and agree not to disclose or
                    misuse such information.
            </span>
    },
    {
        name: "affiliation",
        options: ["A healthcare professional (HCP)", "A government official", "Neither of the above"],
        title: "Professional Affiliation Disclosure",
        text: <span>
                <div>
                    I confirm that I'm registering as one of the following:
                </div>
                <br/>
                <div>
                    If you are a HCP or government official, your participation may be subject to
                    tracking and reporting under applicable healthcare and ethics laws
                </div>
        </span>
    },
    {
        name: "consent",
        title: "Consent to Data Collection and Use",
        text: <span>
            I understand that the information I provide (such as my name, email, employer, and
            registration responses) may be collected and used by the event organizers to administer
            the event, communicate with me before and after the event, and fulfill legal and
            regulatory obligations. My information will not be sold or shared for unrelated third-party
            marketing. I understand it may be stored for up to [five (5)] years and I may request
            access to or deletion of my data by contacting [contact@pactsummit.com]
        </span>
    },
    {
        name: "recording",
        title: "Recording and Media Release",
        text: <span>
             I understand that this event may be recorded and that my voice, image, or participation
            may appear in audio or video footage. I give permission for the event organizers to use
            such recordings for educational, internal training, and promotional purposes, and retain
            them for up to [five (5)] years
        </span>
    },
    {
        name: "raffle",
        title: "Raffle Participation Acknowledgement",
        text: <span>
             I understand that any raffle or prize drawing held in connection with this event is optional,
            free to enter, and not tied to any purchase, endorsement, or required interaction.
            Winners will be selected randomly, and raffle prizes are not intended to influence
            prescribing, purchasing, or professional decisions
        </span>
    }
]